import { NotificationService, CONSTANT, GridDataSource, LoaderService, ErrorService, EVENTO, TOOLTIPS, ICONS, ACTIONS, TYPEMESSAGE, UtilityService } from "../../../../shared/session/index";
import { CustomValidators, RegularExpression, RegularExpressionMessage } from '../../../../shared/validation/customvalidation';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { Documento, Idocumento } from '../shared/documento.model'
import { DocumentoService } from '../shared/documento.service'
import { FileuploadComponent } from "src/app/shared/fileupload/fileupload.component";
import { FileuploadService } from "src/app/shared/fileupload/fileupdate.service";

@Component({
  selector: 'app-documento-new',
  templateUrl: 'documento-new.component.html',
})
export class DocumentoNewComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() data: any;
  @ViewChild(FileuploadComponent) fileuploadComponent: FileuploadComponent;
  @Input() titlePage: string;
  @Input() propietarioID: string;

  formGroupNewDocumento: FormGroup;
  msgSuccessInsert: string;
  msgErrorInsert: string;
  obligatorioMsg: string;
  documento: Idocumento;
  maxLengthMsg: string;
  clienteName: string;
  nomParametroMaxLength: number;
  passClienteMaxLength: number;
  descripcionMaxLength: number;
  nomClientePatternMsg: string = RegularExpressionMessage.LETRAS_TILDE_ENIE_MSG;
  // titlePage: string;
  buttonGroup: any;
  nomPathMaxLength: number;
  public typeImage: number;

  constructor(
    private loaderService: LoaderService,
    private fileuploadService: FileuploadService,
    private documentoService: DocumentoService,
    private notificationService: NotificationService,
    public fb: FormBuilder) { }

  ngOnInit() {
    this.documento = new Documento(1, "", "", "", true, "", "", "", "", "", "");
    this.msgSuccessInsert = 'Se registró satisfactoriamente';
    this.msgErrorInsert = 'Error al registrar Documento ';
    this.obligatorioMsg = 'Campo Obligatorio';
    this.maxLengthMsg = 'El tamaño máximo es de ';
    this.nomParametroMaxLength = 100;
    this.typeImage = CONSTANT.typeImage.edit;
    this.passClienteMaxLength = 20;
    this.descripcionMaxLength = 250;
    this.buttonGroup = [
      { tooltip: TOOLTIPS.save, icon: ICONS.save, action: ACTIONS.save }
    ];
    this.setValuesFormBuilder();
    // this.propietarioID="CL00000001";
  }

  private setValuesFormBuilder() {
    this.formGroupNewDocumento = this.fb.group({
      descripcion: ['', Validators.compose([Validators.required,])],
    });
  }

  changeEvent(documento: Idocumento) {
    this.data.documento = { ID: documento.documentoID, Name: documento.descripcion };
    this.onChangeEvent.emit({ evento: EVENTO.consultar, data: this.data });
  }

  formGroupNewDocumentoSubmit(event) {
    if (this.formGroupNewDocumento.invalid)
      return;
    this.documento.propietarioID = this.data.user.ID;
    this.documento.descripcion = event.value.descripcion;
    this.fileuploadComponent.insertFile(CONSTANT.imagen.clase.documento, CONSTANT.imagen.tipo.usuario, "", this.documento.propietarioID.toString());
    if (this.fileuploadComponent.imageName)
      this.documento.FotoRuta = this.fileuploadComponent.imageName;
    else
      this.documento.FotoRuta = '';

    this.documento.claseArchivo = CONSTANT.imagen.clase.documento;
    if (this.documento.FotoRuta == "") {
      this.notificationService.error("Debe subir una imagen ")
      return;
    } else {
      this.insertarDocumento(this.documento);
    }

  }

  private insertarDocumento(documento: Idocumento) {
    this.loaderService.show();
    this.documentoService.insertarDocumento(documento)
      .subscribe(res => {
        documento.documentoID = res;
        this.changeEvent(documento);
        this.notificationService.successful("Se grabo satisfactoriamente");
      },
        error => {
          this.notificationService.error(this.msgErrorInsert);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }

}
